import { TierItem } from "../pages/components/tierList";

export const escapeRoomList: TierItem[] = [
    { name: "Fresh Meat — Locked Room — Omaha, NE", tier: "Won" },
    { name: "Casino Heist — EscapeWorks — Denver, CO", tier: "Lost" },
    { name: "Area 51 S-4 — The Room — Wichita, KS", tier: "Lost" },
    { name: "Sea Voyage — Industrial Escape Rooms — Omaha, NE", tier: "Lost" },
    { name: "Bermuda Triangle — Industrial Escape Rooms — Omaha, NE", tier: "Lost" },
    { name: "Blackbeard's Treasure — Industrial Escape Rooms — Omaha, NE", tier: "Lost" },
    { name: "Moriarty's Parlor — Industrial Escape Rooms — Omaha, NE", tier: "Lost" },
    { name: "Bake Off — Location Unknown — Fort Lauderdale, FL", tier: "Won" },
    { name: "Power Bomb — Mind Meld Escape Rooms — Omaha, NE", tier: "Won" },
    { name: "Death by Wine — Locked Room — Omaha, NE", tier: "Won" },
    { name: "Butcher — Location Unknown — Sacramento, CA", tier: "Won" },
    { name: "Reindeer Games — House of Conundrum", tier: "Won" },
    { name: "The Gambler — Get Out: Omaha", tier: "Won" },
    { name: "Y2K — Get Out: Omaha", tier: "Won" },
    { name: "Hotel Paranoia — Get Out: Omaha", tier: "Won" },
    { name: "Saving Lincoln — House of Conundrum", tier: "Won" },
    { name: "The Warlocked — Escape Chambers — Des Moines, IA", tier: "Won" },
    { name: "Desruc's Candy Shop — Oh Key! — Blackfoot, ID", tier: "Won" },
    { name: "Black Bayou — Oh Key! — Blackfoot, ID", tier: "Lost" },
    { name: "The Great Potato Escape — Oh Key! — Blackfoot, ID", tier: "Lost" },
];
